import { jsx as _jsx } from "react/jsx-runtime";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import Input from './input';
import styles from './search-input.module.css';
export const SearchInput = (props) => {
    const { t } = useTranslation();
    return (_jsx(Input, Object.assign({ placeholder: t('search-input.placeholder', 'Search for...'), InputProps: {
            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchIcon, { "data-testid": "search-icon", className: styles.icon }) })),
            classes: {
                root: styles.input,
            },
        } }, props)));
};
export default SearchInput;
